up.compiler('[data-navigation-video-ad="dismiss"]', (element: HTMLElement) => {
  element.addEventListener('click', function (event: MouseEvent) {
    element.closest('[data-navigation-video-ad="container"]')!.remove()
    event.preventDefault()
  })
})
